import { ApplicationState } from '../reducers';
import { createSelector } from '@ngrx/store';

export const selectExtraCostConfigFile = (state: ApplicationState) =>
  state.extraCostConfigFile;

export const selectExtraCostInfoPagesByProductIds = (productIds: string[]) =>
  createSelector(selectExtraCostConfigFile, (state) => {
    let explanationIntroPageKeys: string[] = [];
    if (state.extraCostConfig && !state.extraCostConfig.hasError) {
      productIds.forEach((productId) => {
        const productIdRows = state.extraCostConfig.rows.find(
          (row) => row[0] === productId
        );
        if (productIdRows?.length > 0) {
          explanationIntroPageKeys.push(productIdRows[1]);
        }
      });
    }
    return Array.from(new Set(explanationIntroPageKeys)) || [];
  });
